/* src/app/features/tarefas/contrato-scc/tarefas-contrato-scc.component.scss */
h5 {
  margin-bottom: 40px;
}
.submit.col-auto {
  margin-top: 20px;
}
.d-flex.title {
  padding-right: 724px;
  font-weight: bold;
}
.d-flex.title2 {
  padding-right: 652px;
  font-weight: bold;
}
.d-flex.title3 {
  padding-right: 700px;
  font-weight: bold;
}
.d-flex.title4 {
  padding-right: 706px;
  font-weight: bold;
}
.erro {
  color: red;
}
/*# sourceMappingURL=tarefas-contrato-scc.component.css.map */
